
/**
 * Module dependencies.
 */

import { applications } from 'src/core/collections-config/applications';
import { effects } from 'src/core/collections-config/effects';

/**
 * Export `availableFiltersKeys`.
 */

export const availableFiltersKeys = {
  application: 'application_id',
  collection: 'collection_id',
  effect: 'effect'
} as const;

/**
 * Export `availableFiltersValues`.
 */

export const availableFiltersValues = {
  [availableFiltersKeys.application]: Object.values(applications),
  [availableFiltersKeys.effect]: Object.values(effects)
};
